// VersionChecker.js — Add to your root App component
// Checks for new deployments every 5 minutes and prompts users to refresh
import React, { useEffect, useState } from 'react';
import { notification, Button } from 'antd';

const APP_VERSION = process.env.REACT_APP_VERSION || '1.0.0';
const CHECK_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

const VersionChecker = () => {
  const [hasUpdate, setHasUpdate] = useState(false);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        // Fetch version.json from public folder (create this file in /public/version.json)
        // Netlify/S3: update this file on each deploy
        const resp = await fetch('/version.json?t=' + Date.now(), { cache: 'no-store' });
        if (!resp.ok) return;
        const data = await resp.json();
        const deployedVersion = data.version;
        const storedVersion   = localStorage.getItem('mhb_portal_version');

        if (storedVersion && storedVersion !== deployedVersion) {
          // New version detected — show update notification
          setHasUpdate(true);
          notification.info({
            key: 'version-update',
            message: 'Update Available',
            description: 'A new version of My Home Buddha is available. Refresh to get the latest features and fixes.',
            duration: 0, // stays until dismissed
            btn: (
              <Button type="primary" size="small"
                style={{ background: "#1A2280", borderColor: "#1A2280" }}
                onClick={() => {
                  localStorage.setItem('mhb_portal_version', deployedVersion);
                  window.location.reload(true);
                }}>
                Refresh Now
              </Button>
            ),
          });
        } else if (!storedVersion) {
          // First load — store current version
          localStorage.setItem('mhb_portal_version', deployedVersion);
        }
      } catch (e) {
        // Silent fail — version check is non-critical
      }
    };

    // Check on mount
    checkVersion();

    // Check every 5 minutes while app is open
    const interval = setInterval(checkVersion, CHECK_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  return null; // Renders nothing — just runs the check
};

export default VersionChecker;

/* 
SETUP INSTRUCTIONS:
1. Add this file to src/components/VersionChecker.js
2. In your root App.js, import and add: <VersionChecker />
3. Create /public/version.json:
   { "version": "1.0.1", "built": "2026-05-29" }
4. On each deploy: update version.json with a new version string
   The notification will appear automatically for users with older versions
*/
